import React from 'react';
import { PRIORITIES } from '../constants';

const RequestDetailsSection = ({ 
  formData, 
  taTypes,
  isLoadingTATypes,
  loading, 
  handleChange 
}) => {
  return (
    <>
      <div className="col-span-full mt-4">
        <h3 className="text-black font-semibold mb-4 font-poppins text-lg">
          Request Details
        </h3>
      </div>

      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
          Priority <span className="text-red-500">*</span>
        </label>
        <select
          name="priority"
          value={formData.priority}
          onChange={handleChange}
          disabled={loading}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
        >
          <option value="">Select Priority</option>
          {PRIORITIES.map((priority) => (
            <option key={priority.value} value={priority.value}>
              {priority.label}
            </option>
          ))}
        </select>
      </div>

      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
          TA Type <span className="text-red-500">*</span>
        </label>
        <select
          name="taType"
          value={formData.taType}
          onChange={handleChange}
          disabled={loading || isLoadingTATypes}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
        >
          <option value="">Select TA Type</option>
          {taTypes && taTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
          <option value="others">Others</option>
        </select>
        {isLoadingTATypes && (
          <div className="flex items-center mt-2">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
            <span className="text-sm text-gray-600 font-poppins">Loading TA types...</span>
          </div>
        )}
      </div>

      {formData.taType === 'others' && (
        <div className="relative">
          <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
            Specify TA Type <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="otherTaType"
            value={formData.otherTaType}
            onChange={handleChange}
            required
            disabled={loading}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
            placeholder="Please specify the type of technical assistance"
          />
        </div>
      )}
    </>
  );
};

export default RequestDetailsSection; 